import React from "react";
import Nav from "./common/Nav";
import Footer from "./common/Footer";
import ServicesList from "./common/ServiceList";

const Services = () => {
    return (
        <div>
            <Nav />
            <section className="brdcrm">
                <h2>Services</h2>
            </section>
            <ServicesList />
            <Footer />
        </div>
    );
}

export default Services;